import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import React from 'react'
import defaultImg from "../../components/images/defaultPerson.png";
import trainerimg from '../../memberportal/assets/images/coaching.png';
import easyshort from '../../memberportal/assets/images/Easymob.png';
import offerimg from '../../memberportal/assets/images/offering.png';
import moment from "moment";

const AvailableSessionsMobile = ({ event, plans, handleclassevent, handleevents, logourl }) => {

    if (!event) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="alert alert-warning text-center">
                    <i className="fas fa-exclamation-triangle fa-2x mb-3"></i>
                    <h4>Event Not Found</h4>
                    <p>The requested event could not be loaded.</p>
                </div>
            </div>
        );
    }

    const slotLimit = (event) => {
        return event.slotsRemaining - event.slotsBooked
    }

    const isFutureEvent = () => {

        const endDate = new Date(event?.end);

        const combinedEndDateTime = moment(endDate)
            .set({
                hour: moment(event.extendedProps.endTime, "hh:mm A").hour(),
                minute: moment(event.extendedProps.endTime, "hh:mm A").minute(),
                second: 0,
            })
            .toDate();

        return new Date() < combinedEndDateTime;
    };

    const handleBookevent = (event) => {
        handleclassevent(event)
    }


    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };
    return (
        <>
            <div className='mobcontainer-avisessions'>
                <div className='mobheader-avisession'>
                    <div>
                        <div className="short-logo">
                            <img src={logourl ? logourl : easyshort} alt="User" />
                        </div>
                    </div>
                    <div>
                        <h5 className='m-0'>Available Sessions</h5>
                    </div>
                    <div>
                        <div className="user-avatar mob-user">
                            <img src={defaultImg} alt="User" />
                        </div>
                    </div>
                </div>
                <div className='mobbody-avisession mt-1'>
                    <div className='mobbodyheader'>
                        <div className='d-flex justify-content-between '>
                            <h6 className='mt-1 ps-1'>Sessions Details</h6>
                            <h6 className='m-0 pe-2' onClick={handleevents}>
                                <MDBIcon
                                    fas
                                    icon="calendar-alt"
                                    className='me-1'
                                /> See More
                            </h6>
                        </div>
                        <div className='sessioncard mb-4 position-relative'>
                            <div className="flex-grow-1 square border-end me-2 pe-2">
                                <div className='d-flex justify-content-between mb-3'>
                                    <div className='seccion-titeltext'>
                                        <h6 className='text-primary sentitel m-0'>{event.title}</h6>
                                        <label> {new Date(event.start).toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        }).replace(",", " -")}</label>
                                    </div>

                                </div>

                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className="session-trainer d-flex align-items-center">
                                        <div className='trainer-dp trainpic me-2'>
                                            <img src={trainerimg} alt="" />
                                        </div>
                                        <div>
                                            <p className='m-0 text-liner'>{event.extendedProps?.trainer || "Professional Trainer"}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='d-flex align-items-center justify-content-center p-2 text-center'>
                                <div>
                                    <h5 className='m-0'><span className='rupee'>₹</span>{(event?.extendedProps?.price) ? (event.extendedProps.price).toLocaleString("en-IN") : "0"}</h5>
                                    <MDBBtn
                                        className={(isFutureEvent()) ? ((slotLimit(event.extendedProps)) === 0 ? "btn-warning nav-btn py-1 px-2 mt-2 pt-1" : 'nav-btn py-1 px-2 mt-2 pt-1') : 'btn-danger nav-btn py-1 px-2 mt-2 pt-1'}
                                        // className="nav-btn py-1 px-2 mt-2 pt-1"
                                        onClick={(isFutureEvent()) ? ((slotLimit(event.extendedProps)) === 0 ? undefined : () => handleBookevent(event)) : undefined}><span> {(isFutureEvent()) ? ((slotLimit(event.extendedProps)) === 0 ? <div>
                                            Slots full</div> : <div>
                                            Book Now</div>) : <div>
                                            Completed</div>}</span></MDBBtn>
                                </div>
                            </div>

                            {event?.extendedProps?.membershipdiscount?.length > 0 && <div className='discount-seactin'>
                                <MDBIcon fas icon="certificate" className='dis-tag' size='lg' />
                                <MDBIcon fas icon="percentage" size='sm' className='dis-pers' />
                            </div>}
                        </div>
                    </div>
                    <div className='mobbody-body'>
                        <div className='mb-3'>
                            <h6 className='ps-1'>Event Details</h6>
                            <div className='sessioncard flex-wrap'>
                                <div className='mb-3 w-50'>
                                    <label className='text-secondary'>Date & Time</label>
                                    <p className='m-0 text-dark'>{new Date(event.start).toLocaleString()}</p>
                                </div>
                                <div className='mb-3 w-50'>
                                    <label className='text-secondary'>Duration</label>
                                    <p className='m-0 text-dark'>{event?.extendedProps?.classInfo?.duration || 0} minutes</p>
                                </div>
                                {/* <div className='mb-3 w-50'>
                                    <label className='text-secondary'>Available Slots</label>
                                    <p className='m-0 text-dark'>23 remaining(of 25)</p>
                                </div> */}
                                <div className='mb-3 w-50'>
                                    <label className='text-secondary'>Level</label>
                                    <p className='m-0 text-dark'>{event.extendedProps?.classInfo.level || "All Levels"}</p>
                                </div>
                                <div className='mb-3 w-50'>
                                    <label className='text-secondary'>Category</label>
                                    <p className='m-0 text-dark'>{event.extendedProps?.classInfo.category || "General"}</p>
                                </div>
                                <div className='mb-3 w-50'>
                                    <label className='text-secondary'>Location</label>
                                    <p className='m-0 text-dark'>{event?.extendedProps?.scheduleinfo?.location || "Main Studio"}</p>
                                </div>
                                <div className='mb-3'>
                                    <label className='text-secondary'>Description</label>

                                    <p className='description-content mb-1' title={stripHtmlTags(event.extendedProps.description ? event.extendedProps.description : "--")} dangerouslySetInnerHTML={{ __html: event.extendedProps.description ? event.extendedProps.description : "--" }} />
                                </div>
                            </div>
                        </div>
                        {event?.extendedProps?.membershipdiscount?.length > 0 && (
                            <div className="mb-3">
                                <h6 className="ps-1 text-dark">Membership Discounts %</h6>

                                <div>
                                    {(() => {
                                        let globalIndex = 0; // keeps count across all cards

                                        return plans.map((plan) => {
                                            const subplanIds = plan.subplans?.map((sp) => sp._id) || [];
                                            const relatedDiscounts = event.extendedProps.membershipdiscount.filter(
                                                (item) =>
                                                    item.membershipname === plan._id ||
                                                    subplanIds.includes(item.membershipname)
                                            );

                                            if (relatedDiscounts.length === 0) return null;

                                            const allSubplansCovered =
                                                subplanIds.length > 0
                                                    ? subplanIds.every((id) =>
                                                        event.extendedProps.membershipdiscount.some(
                                                            (item) => item.membershipname === id
                                                        )
                                                    )
                                                    : false;

                                            const uniqueDiscounts = [
                                                ...new Set(relatedDiscounts.map((d) => d.discount)),
                                            ];

                                            // Case 1: All subplans covered + same discount → show main plan
                                            if (allSubplansCovered && uniqueDiscounts.length === 1) {
                                                const card = (
                                                    <div
                                                        key={plan._id}
                                                        className={`offercard ${globalIndex % 2 === 0 ? "offer1" : "offer2"
                                                            }`}
                                                    >
                                                        <div className="offer-setion">
                                                            <div>
                                                                <label className="text-dark pe-2">
                                                                    Save up to <b>{uniqueDiscounts[0]}</b>% off on{" "}
                                                                    {plan.name} membership
                                                                </label>
                                                            </div>
                                                            <img src={offerimg} alt="offer" />
                                                        </div>
                                                    </div>
                                                );
                                                globalIndex++; // increment for next card
                                                return card;
                                            }

                                            // Case 2: Some subplans missing or different discounts → show individually
                                            return relatedDiscounts.map((item) => {
                                                const subplan = plan.subplans?.find(
                                                    (sp) => sp._id === item.membershipname
                                                );
                                                const planLabel = subplan
                                                    ? `${plan.name} - ${subplan.name}`
                                                    : plan.name;

                                                const card = (
                                                    <div
                                                        key={item._id}
                                                        className={`offercard ${globalIndex % 2 === 0 ? "offer1" : "offer2"
                                                            }`}
                                                    >
                                                        <div className="offer-setion">
                                                            <div>
                                                                <label className="text-dark pe-2">
                                                                    Save up to <b>{item.discount}</b>% off on {planLabel}{" "}
                                                                    membership
                                                                </label>
                                                            </div>
                                                            <img src={offerimg} alt="offer" />
                                                        </div>
                                                    </div>
                                                );

                                                globalIndex++;
                                                return card;
                                            });
                                        });
                                    })()}
                                </div>
                            </div>
                        )}




                    </div>

                </div >
            </div >
        </>
    )
}

export default AvailableSessionsMobile
